export default "__VITE_ASSET__5d1f1841__"